import { Chip } from '@pocketlaw/tetris';
import { getSearchEntityTypeText } from 'app/domains/global-search/utils/getSearchEntityTypeText';
export function EntityType(props) {
    const { type } = props;
    return <Chip appearance="secondary" variant="outline" size="small" label={getSearchEntityTypeText(type)}/>;
}
